// -- Kalman Filter -- Control Systems -----------------------------------------------

const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL:          { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// -- Palette --
const RED    = '#c0392b';
const DKRED  = '#7B0D0D';
const BLUE   = '#2E75B6';
const ORANGE = '#e07b00';
const GREEN  = '#27ae60';
const PURPLE = '#8e44ad';
const TEAL   = '#16a085';
const LTRED  = '#fff5f5';
const LTBLU  = '#eaf3ff';
const LTORG  = '#fff7e6';
const LTGRN  = '#f0fef4';
const LTPUR  = '#f5eeff';
const LTTEAL = '#e8faf5';
const BORDER = '#f0cece';

function Defs() {
  return (
    <defs>
      <marker id="aRed"    markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={RED}/></marker>
      <marker id="aBlue"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={BLUE}/></marker>
      <marker id="aOrange" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={ORANGE}/></marker>
      <marker id="aGreen"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={GREEN}/></marker>
      <marker id="aPurple" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={PURPLE}/></marker>
      <marker id="aTeal"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill={TEAL}/></marker>
      <marker id="aGray"   markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#888"/></marker>
    </defs>
  );
}

function Blk({ x, y, w, h, fill, stroke, label, sub, fs=12 }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={5} fill={fill} stroke={stroke} strokeWidth="1.5"/>
      <text x={x+w/2} y={y+h/2+(sub?-5:5)} textAnchor="middle" fontSize={fs} fill={stroke} fontWeight="700">{label}</text>
      {sub && <text x={x+w/2} y={y+h/2+11} textAnchor="middle" fontSize="9" fill={stroke} opacity="0.85">{sub}</text>}
    </g>
  );
}

function Arr({ x1, y1, x2, y2, color=RED, marker='aRed', dash=false, lbl='', lx, ly }) {
  return (
    <g>
      <line x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth="1.8"
        strokeDasharray={dash ? '5 3' : 'none'} markerEnd={'url(#' + marker + ')'}/>
      {lbl && (
        <text x={lx || ((x1+x2)/2)} y={ly || ((y1+y2)/2 - 5)}
          textAnchor="middle" fontSize="10" fill={color} fontWeight="600">{lbl}</text>
      )}
    </g>
  );
}

function Card({ x, y, w, h, bg, bc, lines }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
      {lines.map((t, i) => (
        <text key={i} x={x+8} y={y+16+i*15}
          fontSize={i===0 ? '11' : '10'} fill={i===0 ? bc : '#444'} fontWeight={i===0 ? '700' : '400'}>{t}</text>
      ))}
    </g>
  );
}

// Gaussian bell curve helper
function Gaussian({ cx, cy, sigma, amp, color, W, scaleX, scaleY, pts=80 }) {
  const points = Array.from({ length: pts }, (_, k) => {
    const x = cx - 3.5 * sigma + k * (7 * sigma / (pts - 1));
    const y = amp * Math.exp(-0.5 * Math.pow((x - cx) / sigma, 2));
    return (cx + (x - cx) * scaleX) + ',' + (cy - y * scaleY);
  }).join(' ');
  return <polyline points={points} fill="none" stroke={color} strokeWidth="2.2"/>;
}

// =================================================================
// Diagram 1 -- Predict-Update cycle (the two-step loop)
// =================================================================
function DiagramPredictUpdate() {
  const W = 900, H = 370;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>The Kalman Filter Predict-Update Cycle</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Large cycle arrows */}
        {/* Predict box */}
        <rect x={100} y={60} width={280} height={110} rx={8} fill={LTBLU} stroke={BLUE} strokeWidth="2.5"/>
        <text x={240} y={100} textAnchor="middle" fontSize="16" fill={BLUE} fontWeight="700">PREDICT</text>
        <text x={240} y={118} textAnchor="middle" fontSize="11" fill={BLUE}>x_hat_k|k-1 = A * x_hat_k-1|k-1 + B*u</text>
        <text x={240} y={134} textAnchor="middle" fontSize="11" fill={BLUE}>P_k|k-1 = A * P_k-1|k-1 * A^T + Q</text>
        <text x={240} y={152} textAnchor="middle" fontSize="9" fill={BLUE} fontStyle="italic">Uses model dynamics + process noise Q</text>

        {/* Update box */}
        <rect x={520} y={60} width={310} height={110} rx={8} fill={LTORG} stroke={ORANGE} strokeWidth="2.5"/>
        <text x={675} y={94} textAnchor="middle" fontSize="16" fill={ORANGE} fontWeight="700">UPDATE (Correct)</text>
        <text x={675} y={112} textAnchor="middle" fontSize="11" fill={ORANGE}>K_k = P_k|k-1*C^T * (C*P_k|k-1*C^T + R)^(-1)</text>
        <text x={675} y={128} textAnchor="middle" fontSize="11" fill={ORANGE}>x_hat_k|k = x_hat_k|k-1 + K_k*(y_k - C*x_hat_k|k-1)</text>
        <text x={675} y={144} textAnchor="middle" fontSize="11" fill={ORANGE}>P_k|k = (I - K_k*C) * P_k|k-1</text>
        <text x={675} y={158} textAnchor="middle" fontSize="9" fill={ORANGE} fontStyle="italic">Uses measurement y_k + noise R</text>

        {/* Arrow: Predict to Update */}
        <Arr x1={380} y1={115} x2={520} y2={115} color={GREEN} marker="aGreen" lbl="x_hat_k|k-1, P_k|k-1" lx={450} ly={105}/>

        {/* Arrow: Update back to Predict (loop) */}
        <path d="M 675 170 Q 675 230 400 260 Q 200 280 175 170" fill="none" stroke={PURPLE} strokeWidth="2" strokeDasharray="6 3"/>
        <polygon points="175,170 168,180 182,178" fill={PURPLE}/>
        <text x={400} y={250} textAnchor="middle" fontSize="10" fill={PURPLE} fontWeight="700">x_hat_k|k, P_k|k fed back as new prior</text>

        {/* Input arrows */}
        <Arr x1={40} y1={115} x2={100} y2={115} color={BLUE} marker="aBlue" lbl="u_k (control)" lx={70} ly={105}/>
        <Arr x1={675} y1={10} x2={675} y2={60} color={ORANGE} marker="aOrange" lbl="y_k (measurement)" lx={675} ly={5}/>

        {/* Output */}
        <Arr x1={830} y1={115} x2={890} y2={115} color={RED} marker="aRed" lbl="x_hat_k" lx={860} ly={105}/>

        {/* Noise inputs */}
        <text x={240} y={36} textAnchor="middle" fontSize="10" fill={BLUE}>Process noise Q</text>
        <Arr x1={240} y1={42} x2={240} y2={60} color={BLUE} marker="aBlue" dash={true}/>
        <text x={540} y={36} textAnchor="middle" fontSize="10" fill={ORANGE}>Measurement noise R</text>
        <Arr x1={540} y1={42} x2={540} y2={60} color={ORANGE} marker="aOrange" dash={true}/>

        {/* Bottom panels: what each step does */}
        <rect x={10} y={290} width={420} height={70} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={220} y={308} textAnchor="middle" fontSize="12" fill={BLUE} fontWeight="700">PREDICT: propagate estimate forward in time</text>
        {[
          'Time update: advance state estimate using dynamics model',
          'Covariance grows: uncertainty increases (P gets larger)',
          'Uses system matrix A, input B, process noise covariance Q',
        ].map((t, i) => (
          <text key={i} x={18} y={320+i*14} fontSize="9.5" fill="#444">{t}</text>
        ))}

        <rect x={460} y={290} width={430} height={70} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={675} y={308} textAnchor="middle" fontSize="12" fill={ORANGE} fontWeight="700">UPDATE: incorporate new measurement</text>
        {[
          'Measurement update: pull estimate toward sensor reading',
          'Covariance shrinks: measurement reduces uncertainty (P smaller)',
          'Uses output matrix C, measurement noise covariance R, Kalman gain K',
        ].map((t, i) => (
          <text key={i} x={468} y={320+i*14} fontSize="9.5" fill="#444">{t}</text>
        ))}
      </svg>
      <div style={S.dCaption}>
        The Kalman filter operates in a two-step recursive loop. The Predict step propagates the current state estimate forward in time using the system dynamics model, increasing uncertainty. The Update step then incorporates a new sensor measurement, correcting the prediction and reducing uncertainty. The filter optimally balances trust between model and measurement via the Kalman gain K.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 2 -- Gaussian intuition: prior, likelihood, posterior
// =================================================================
function DiagramGaussianIntuition() {
  const W = 900, H = 340;

  // Three panels: prior, likelihood, posterior (fusion)
  const panels = [
    {
      x: 10, title: 'Prior (Predict result)', color: BLUE,
      mu: 5.0, sigma: 1.8, label: 'N(5, 1.8^2)',
      desc: 'Model prediction: wide/uncertain',
    },
    {
      x: 310, title: 'Likelihood (Measurement)', color: ORANGE,
      mu: 7.0, sigma: 1.0, label: 'N(7, 1.0^2)',
      desc: 'Sensor reading: narrower',
    },
    {
      x: 610, title: 'Posterior (Updated estimate)', color: RED,
      mu: 6.22, sigma: 0.84, label: 'N(6.22, 0.84^2)',
      desc: 'Fused: tighter, between both',
    },
  ];

  const PW = 270, PH = 200;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Bayesian Fusion -- Combining Prior Belief with Measurement</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {panels.map(({ x, title, color, mu, sigma, label, desc }) => {
          const cy = x === 610 ? 160 : 160;
          const plotX = x + 14, plotY = 40, plotW = PW - 28, plotH = PH;
          const scaleX = plotW / (7 * 2.5);
          const scaleY = plotH * 0.75;
          const muPx = plotX + plotW / 2 + (mu - 6) * scaleX;

          return (
            <g key={x}>
              <rect x={x} y={10} width={PW} height={PH + 100} rx={5} fill="#fff" stroke={BORDER}/>
              <text x={x+PW/2} y={28} textAnchor="middle" fontSize="12" fill={color} fontWeight="700">{title}</text>
              <rect x={plotX} y={plotY} width={plotW} height={plotH} rx={3} fill="#fafafa" stroke="#eee"/>

              {/* x axis */}
              <line x1={plotX} y1={plotY+plotH} x2={plotX+plotW} y2={plotY+plotH} stroke="#ccc" strokeWidth="1"/>
              {[3,4,5,6,7,8,9].map(v => {
                const px = plotX + plotW/2 + (v-6)*scaleX;
                return px > plotX && px < plotX+plotW ? (
                  <g key={v}>
                    <line x1={px} y1={plotY+plotH} x2={px} y2={plotY+plotH+4} stroke="#bbb" strokeWidth="1"/>
                    <text x={px} y={plotY+plotH+14} textAnchor="middle" fontSize="9" fill="#bbb">{v}</text>
                  </g>
                ) : null;
              })}

              {/* Gaussian curve */}
              <Gaussian cx={mu} cy={plotY+plotH} sigma={sigma} amp={1}
                color={color} scaleX={scaleX} scaleY={scaleY}/>

              {/* Fill under curve */}
              {(() => {
                const pts = Array.from({ length: 60 }, (_, k) => {
                  const xv = mu - 3.5*sigma + k*(7*sigma/59);
                  const yv = Math.exp(-0.5*Math.pow((xv-mu)/sigma,2));
                  return (plotX + plotW/2 + (xv-6)*scaleX) + ',' + (plotY+plotH - yv*scaleY);
                });
                const startX = plotX + plotW/2 + (mu-3.5*sigma-6)*scaleX;
                const endX = plotX + plotW/2 + (mu+3.5*sigma-6)*scaleX;
                const base = plotY+plotH;
                return (
                  <polygon
                    points={startX+','+base+' '+pts.join(' ')+' '+endX+','+base}
                    fill={color} opacity="0.12"/>
                );
              })()}

              {/* Mean line */}
              <line x1={muPx} y1={plotY+10} x2={muPx} y2={plotY+plotH} stroke={color} strokeWidth="1.5" strokeDasharray="4 2" opacity="0.7"/>
              <text x={muPx} y={plotY+8} textAnchor="middle" fontSize="9" fill={color} fontWeight="700">mu={mu}</text>

              {/* Sigma brackets */}
              <line x1={muPx - sigma*scaleX} y1={plotY+plotH+20} x2={muPx+sigma*scaleX} y2={plotY+plotH+20} stroke={color} strokeWidth="1.2"/>
              <line x1={muPx-sigma*scaleX} y1={plotY+plotH+16} x2={muPx-sigma*scaleX} y2={plotY+plotH+24} stroke={color} strokeWidth="1.2"/>
              <line x1={muPx+sigma*scaleX} y1={plotY+plotH+16} x2={muPx+sigma*scaleX} y2={plotY+plotH+24} stroke={color} strokeWidth="1.2"/>
              <text x={muPx} y={plotY+plotH+34} textAnchor="middle" fontSize="9" fill={color}>1 sigma</text>

              <rect x={x+8} y={plotY+plotH+44} width={PW-16} height={48} rx={3} fill={color === RED ? LTRED : color === BLUE ? LTBLU : LTORG} stroke={color} strokeWidth="1"/>
              <text x={x+PW/2} y={plotY+plotH+60} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">{label}</text>
              <text x={x+PW/2} y={plotY+plotH+76} textAnchor="middle" fontSize="9.5" fill="#444">{desc}</text>
              <text x={x+PW/2} y={plotY+plotH+88} textAnchor="middle" fontSize="9" fill={color}>
                {x===610 ? 'Variance = P_prior*P_meas/(P_prior+P_meas)' : x===10 ? 'Variance = P (covariance)' : 'Variance = R (meas. noise)'}
              </text>
            </g>
          );
        })}

        {/* Fusion arrows */}
        <Arr x1={282} y1={150} x2={308} y2={150} color={GREEN} marker="aGreen" lbl="fuse" lx={295} ly={142}/>
        <Arr x1={582} y1={150} x2={608} y2={150} color={GREEN} marker="aGreen" lbl="=" lx={595} ly={142}/>

        {/* Fusion formula */}
        <rect x={285} y={280} width={330} height={52} rx={4} fill={LTGRN} stroke={GREEN} strokeWidth="1.5"/>
        <text x={450} y={298} textAnchor="middle" fontSize="11" fill={GREEN} fontWeight="700">Bayesian fusion (scalar 1D case):</text>
        <text x={450} y={314} textAnchor="middle" fontSize="10" fill="#333" fontFamily="'Courier New',monospace">mu_post = mu_prior + K*(z - mu_prior)</text>
        <text x={450} y={326} textAnchor="middle" fontSize="10" fill="#333" fontFamily="'Courier New',monospace">K = P_prior / (P_prior + R)  (Kalman gain)</text>
      </svg>
      <div style={S.dCaption}>
        The Kalman filter is a Bayesian estimator. The prior (blue) represents current belief from the model -- wide and uncertain. The likelihood (orange) represents the sensor measurement -- narrower if the sensor is accurate. The posterior (red) is the optimal fusion: its mean lies between the two, weighted by their relative precisions, and its variance is smaller than either input. This geometric picture generalises directly to the multivariate case.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 3 -- 1D scalar worked example (step by step)
// =================================================================
function DiagramScalarExample() {
  const W = 900, H = 420;

  // Scalar system: x_k = x_{k-1} + w (random walk), y_k = x_k + v
  // Q = 1, R = 4, initial P = 2
  const steps = [];
  let xhat = 0, P = 2.0;
  const trueX = [0, 1.2, 1.8, 3.1, 3.5, 4.8];
  const meas  = [0.5, 0.8, 2.6, 2.4, 4.1, 4.4];
  const Q = 1.0, R = 4.0;
  for (let k = 1; k <= 5; k++) {
    const P_pred = P + Q;
    const xhat_pred = xhat;
    const K = P_pred / (P_pred + R);
    const innov = meas[k] - xhat_pred;
    xhat = xhat_pred + K * innov;
    P = (1 - K) * P_pred;
    steps.push({ k, P_pred: P_pred.toFixed(2), K: K.toFixed(3), innov: innov.toFixed(2), xhat: xhat.toFixed(3), P: P.toFixed(3), true_x: trueX[k], meas: meas[k] });
  }

  const bx = 30, by = 220, bw = 840, bh = 160;
  const tMax = 5;
  const toX = t => bx + (t/tMax) * bw;
  const toY = v => by + bh/2 - v * bh * 0.12;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>1D Scalar Example: x_k = x_(k-1) + w,  y_k = x_k + v,  Q=1, R=4</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Steps table */}
        <rect x={10} y={10} width={880} height={200} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={450} y={28} textAnchor="middle" fontSize="13" fill={DKRED} fontWeight="700">Step-by-Step Filter Recursion (5 time steps)</text>

        {/* Table header */}
        {['k', 'True x', 'Meas y', 'P_pred', 'K', 'Innovation', 'x_hat', 'P'].map((h, ci) => {
          const colX = [14, 90, 170, 258, 348, 436, 570, 710];
          return (
            <g key={ci}>
              <rect x={colX[ci]} y={36} width={ci<7?colX[ci+1]-colX[ci]:180} height={26} fill={DKRED} rx={ci===0?3:0}/>
              <text x={colX[ci]+4} y={54} fontSize="11" fill="#fff" fontWeight="700">{h}</text>
            </g>
          );
        })}

        {/* Table rows */}
        {steps.map(({ k, P_pred, K, innov, xhat: xh, P: Pf, true_x, meas: m }, i) => {
          const colX = [14, 90, 170, 258, 348, 436, 570, 710];
          const vals = [k, true_x.toFixed(1), m.toFixed(1), P_pred, K, innov, xh, Pf];
          const bg = i%2===0 ? '#fff5f5' : '#fff';
          return (
            <g key={k}>
              {vals.map((val, ci) => (
                <g key={ci}>
                  <rect x={colX[ci]} y={62+i*26} width={ci<7?colX[ci+1]-colX[ci]:180} height={26} fill={bg} stroke="#f0cece" strokeWidth="0.5"/>
                  <text x={colX[ci]+4} y={79+i*26} fontSize="10.5" fill={ci===6?RED:ci===4?ORANGE:ci===5?GREEN:'#333'}
                    fontFamily="'Courier New',monospace" fontWeight={ci===4||ci===6?'700':'400'}>{val}</text>
                </g>
              ))}
            </g>
          );
        })}

        {/* Legend for columns */}
        <text x={14}  y={198} fontSize="9" fill={RED}>x_hat = updated estimate</text>
        <text x={436} y={198} fontSize="9" fill={GREEN}>Innovation = y - x_hat_pred</text>
        <text x={570} y={198} fontSize="9" fill={ORANGE}>K = Kalman gain</text>

        {/* Time series plot */}
        <rect x={bx} y={by} width={bw} height={bh} rx={4} fill="#fff" stroke={BORDER}/>
        <text x={bx+bw/2} y={by-8} textAnchor="middle" fontSize="11" fill={DKRED} fontWeight="700">Tracking performance over time</text>

        {/* Grid */}
        {[0,1,2,3,4,5,6].map(v => (
          <g key={'hg'+v}>
            <line x1={bx} y1={toY(v)} x2={bx+bw} y2={toY(v)} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={bx-4} y={toY(v)+4} textAnchor="end" fontSize="9" fill="#ccc">{v}</text>
          </g>
        ))}
        {[0,1,2,3,4,5].map(t => (
          <g key={'vg'+t}>
            <line x1={toX(t)} y1={by} x2={toX(t)} y2={by+bh} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={toX(t)} y={by+bh+14} textAnchor="middle" fontSize="9" fill="#bbb">{t}</text>
          </g>
        ))}

        {/* True state */}
        <polyline points={trueX.map((v, t) => toX(t)+','+toY(v)).join(' ')} fill="none" stroke="#ccc" strokeWidth="1.5" strokeDasharray="6 3"/>
        {trueX.map((v, t) => (
          <circle key={t} cx={toX(t)} cy={toY(v)} r={4} fill="#bbb"/>
        ))}

        {/* Measurements */}
        {meas.map((v, t) => (
          <g key={'m'+t}>
            <line x1={toX(t)-5} y1={toY(v)-5} x2={toX(t)+5} y2={toY(v)+5} stroke={ORANGE} strokeWidth="2"/>
            <line x1={toX(t)+5} y1={toY(v)-5} x2={toX(t)-5} y2={toY(v)+5} stroke={ORANGE} strokeWidth="2"/>
          </g>
        ))}

        {/* Estimates */}
        {steps.map(({ k, xhat: xh }) => (
          <circle key={'e'+k} cx={toX(k)} cy={toY(parseFloat(xh))} r={6} fill={RED} opacity="0.9"/>
        ))}
        <polyline points={steps.map(({ k, xhat: xh }) => toX(k)+','+toY(parseFloat(xh))).join(' ')}
          fill="none" stroke={RED} strokeWidth="2"/>

        {/* Legend */}
        <circle cx={bx+40} cy={by+bh-10} r={5} fill="#bbb"/>
        <text x={bx+50} y={by+bh-6} fontSize="9.5" fill="#888">True state</text>
        <line x1={bx+100} y1={by+bh-8} x2={bx+112} y2={by+bh-14} stroke={ORANGE} strokeWidth="2"/>
        <line x1={bx+112} y1={by+bh-8} x2={bx+100} y2={by+bh-14} stroke={ORANGE} strokeWidth="2"/>
        <text x={bx+120} y={by+bh-6} fontSize="9.5" fill={ORANGE}>Measurement (noisy)</text>
        <circle cx={bx+250} cy={by+bh-10} r={5} fill={RED}/>
        <text x={bx+260} y={by+bh-6} fontSize="9.5" fill={RED}>Kalman estimate (x_hat)</text>
        <text x={bx+bw-4} y={by+bh-6} textAnchor="end" fontSize="9" fill="#888">Time step k</text>
      </svg>
      <div style={S.dCaption}>
        A 1D random walk tracked by the Kalman filter. The true state (grey, hidden) drifts; noisy measurements (orange x) have variance R=4; the Kalman estimate (red) stays close to the truth. Notice the Kalman gain K stabilises after a few steps as P converges -- the filter becomes less responsive to new measurements as it becomes more confident in its model.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 4 -- Covariance evolution and Kalman gain
// =================================================================
function DiagramCovarianceGain() {
  const W = 900, H = 360;
  const bx = 50, by = 30, bw = 370, bh = 290;
  const bx2 = 480, bw2 = 380;

  // Simulate P and K over 20 steps
  let P = 10.0;
  const Q = 0.5, R = 3.0;
  const Pseries = [], Kseries = [];
  for (let k = 0; k <= 20; k++) {
    if (k > 0) {
      const Pp = P + Q;
      const K = Pp / (Pp + R);
      P = (1 - K) * Pp;
      Kseries.push({ k, K });
      Pseries.push({ k, P, Pp });
    } else {
      Pseries.push({ k, P, Pp: P });
      Kseries.push({ k, K: 0 });
    }
  }

  const toXp = k => bx + (k/20) * bw;
  const toYp = v => by + bh - v * bh * 0.088;
  const toXk = k => bx2 + (k/20) * bw2;
  const toYk = v => by + bh - v * bh * 0.9;

  // Steady-state P: P_ss = Q/2 + sqrt((Q/2)^2 + Q*R)
  const Pss = Q/2 + Math.sqrt(Math.pow(Q/2,2) + Q*R);
  const Kss = Pss / (Pss + R);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Covariance P and Kalman Gain K Converge to Steady-State Values</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left: P evolution */}
        <rect x={bx} y={by} width={bw} height={bh} rx={4} fill="#fff" stroke={BORDER}/>
        <text x={bx+bw/2} y={by-10} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">Covariance P (uncertainty)</text>

        {[0,2,4,6,8,10].map(v => (
          <g key={'pv'+v}>
            <line x1={bx} y1={toYp(v)} x2={bx+bw} y2={toYp(v)} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={bx-4} y={toYp(v)+4} textAnchor="end" fontSize="9" fill="#bbb">{v}</text>
          </g>
        ))}
        {[0,5,10,15,20].map(k => (
          <g key={'pk'+k}>
            <line x1={toXp(k)} y1={by} x2={toXp(k)} y2={by+bh} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={toXp(k)} y={by+bh+14} textAnchor="middle" fontSize="9" fill="#bbb">{k}</text>
          </g>
        ))}

        {/* P_predicted (before update) */}
        <polyline points={Pseries.map(({ k, Pp }) => toXp(k)+','+toYp(Pp)).join(' ')}
          fill="none" stroke={BLUE} strokeWidth="1.5" strokeDasharray="5 3"/>
        {/* P_updated */}
        <polyline points={Pseries.map(({ k, P: pv }) => toXp(k)+','+toYp(pv)).join(' ')}
          fill="none" stroke={RED} strokeWidth="2.2"/>

        {/* Steady state line */}
        <line x1={bx} y1={toYp(Pss)} x2={bx+bw} y2={toYp(Pss)} stroke={GREEN} strokeWidth="1.5" strokeDasharray="4 2"/>
        <text x={bx+bw-4} y={toYp(Pss)-5} textAnchor="end" fontSize="9" fill={GREEN}>P_ss={Pss.toFixed(2)}</text>

        <line x1={bx} y1={by+bh} x2={bx+bw} y2={by+bh} stroke="#aaa" strokeWidth="1.2"/>
        <line x1={bx} y1={by} x2={bx} y2={by+bh} stroke="#aaa" strokeWidth="1.2"/>
        <text x={bx+bw/2} y={by+bh+26} textAnchor="middle" fontSize="10" fill="#777">Time step k</text>
        <text x={bx-34} y={by+bh/2} textAnchor="middle" fontSize="10" fill="#777"
          transform={'rotate(-90,' + (bx-34) + ',' + (by+bh/2) + ')'}>Variance P</text>

        {/* Legend */}
        <line x1={bx+10} y1={by+bh-10} x2={bx+30} y2={by+bh-10} stroke={RED} strokeWidth="2"/>
        <text x={bx+34} y={by+bh-6} fontSize="9.5" fill={RED}>P (after update)</text>
        <line x1={bx+130} y1={by+bh-10} x2={bx+150} y2={by+bh-10} stroke={BLUE} strokeWidth="1.5" strokeDasharray="4 2"/>
        <text x={bx+154} y={by+bh-6} fontSize="9.5" fill={BLUE}>P (predicted)</text>

        {/* Right: K evolution */}
        <rect x={bx2} y={by} width={bw2} height={bh} rx={4} fill="#fff" stroke={BORDER}/>
        <text x={bx2+bw2/2} y={by-10} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">Kalman Gain K (0 to 1)</text>

        {[0,0.25,0.5,0.75,1.0].map(v => (
          <g key={'kv'+v}>
            <line x1={bx2} y1={toYk(v)} x2={bx2+bw2} y2={toYk(v)} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={bx2-4} y={toYk(v)+4} textAnchor="end" fontSize="9" fill="#bbb">{v.toFixed(2)}</text>
          </g>
        ))}
        {[0,5,10,15,20].map(k => (
          <g key={'kk'+k}>
            <line x1={toXk(k)} y1={by} x2={toXk(k)} y2={by+bh} stroke="#f5f0f0" strokeWidth="1"/>
            <text x={toXk(k)} y={by+bh+14} textAnchor="middle" fontSize="9" fill="#bbb">{k}</text>
          </g>
        ))}

        <polyline points={Kseries.map(({ k, K }) => toXk(k)+','+toYk(K)).join(' ')}
          fill="none" stroke={ORANGE} strokeWidth="2.2"/>

        {/* Steady state K */}
        <line x1={bx2} y1={toYk(Kss)} x2={bx2+bw2} y2={toYk(Kss)} stroke={GREEN} strokeWidth="1.5" strokeDasharray="4 2"/>
        <text x={bx2+bw2-4} y={toYk(Kss)-5} textAnchor="end" fontSize="9" fill={GREEN}>K_ss={Kss.toFixed(3)}</text>

        <line x1={bx2} y1={by+bh} x2={bx2+bw2} y2={by+bh} stroke="#aaa" strokeWidth="1.2"/>
        <line x1={bx2} y1={by} x2={bx2} y2={by+bh} stroke="#aaa" strokeWidth="1.2"/>
        <text x={bx2+bw2/2} y={by+bh+26} textAnchor="middle" fontSize="10" fill="#777">Time step k</text>
        <text x={bx2-34} y={by+bh/2} textAnchor="middle" fontSize="10" fill="#777"
          transform={'rotate(-90,' + (bx2-34) + ',' + (by+bh/2) + ')'}>Kalman gain K</text>

        {/* Interpretation boxes */}
        <rect x={bx2+10} y={by+20} width={160} height={60} rx={3} fill={LTBLU} stroke={BLUE} strokeWidth="1"/>
        <text x={bx2+18} y={by+36} fontSize="9.5" fill={BLUE} fontWeight="700">K near 1 (start):</text>
        <text x={bx2+18} y={by+50} fontSize="9.5" fill="#444">Trust measurement</text>
        <text x={bx2+18} y={by+64} fontSize="9.5" fill="#444">P_pred large relative to R</text>
        <text x={bx2+18} y={by+78} fontSize="9.5" fill="#444">Uncertainty high</text>

        <rect x={bx2+bw2-180} y={by+20} width={170} height={60} rx={3} fill={LTORG} stroke={ORANGE} strokeWidth="1"/>
        <text x={bx2+bw2-172} y={by+36} fontSize="9.5" fill={ORANGE} fontWeight="700">K steady-state:</text>
        <text x={bx2+bw2-172} y={by+50} fontSize="9.5" fill="#444">Balance P_ss and R</text>
        <text x={bx2+bw2-172} y={by+64} fontSize="9.5" fill="#444">P_ss depends on Q and R</text>
        <text x={bx2+bw2-172} y={by+78} fontSize="9.5" fill="#444">Optimal weighting</text>
      </svg>
      <div style={S.dCaption}>
        Starting from a high initial uncertainty (P=10), the covariance quickly drops and converges to the steady-state value P_ss determined by Q and R. The Kalman gain K likewise converges: early on it is close to 1 (trust measurements), and at steady state it settles at K_ss = P_ss/(P_ss+R). In practice, the steady-state Kalman gain can be pre-computed offline, reducing the filter to a fixed-gain observer identical to the Luenberger observer.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 5 -- Kalman gain vs noise ratio intuition
// =================================================================
function DiagramGainIntuition() {
  const W = 900, H = 320;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Kalman Gain Intuition -- Balancing Model Trust vs Sensor Trust</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Three scenarios */}
        {[
          {
            x: 10, title: 'High R, Low Q', subtitle: '(Trust model, ignore sensor)',
            color: BLUE, K: 0.1, scenario: 'Sensor very noisy',
            modelW: 0.6, sensW: 0.1,
            desc: ['R >> Q: sensor noisy, model accurate', 'K near 0: barely update from y', 'x_hat barely moves toward measurement', 'Example: GPS with large noise'],
          },
          {
            x: 310, title: 'Balanced Q = R', subtitle: '(Equal trust)',
            color: GREEN, K: 0.5, scenario: 'Balanced noise',
            modelW: 0.5, sensW: 0.5,
            desc: ['Q = R: equal trust in model and sensor', 'K = 0.5: average prediction and measurement', 'x_hat moves halfway to measurement', 'Common in practice'],
          },
          {
            x: 610, title: 'Low R, High Q', subtitle: '(Trust sensor, ignore model)',
            color: ORANGE, K: 0.9, scenario: 'Model very uncertain',
            modelW: 0.1, sensW: 0.9,
            desc: ['Q >> R: model uncertain, sensor accurate', 'K near 1: almost replace estimate with y', 'x_hat jumps nearly to measurement', 'Example: precise laser rangefinder'],
          },
        ].map(({ x, title, subtitle, color, K, modelW, sensW, desc }) => {
          const PW = 270, cy = 160;
          return (
            <g key={x}>
              <rect x={x} y={10} width={PW} height={300} rx={5} fill="#fff" stroke={BORDER}/>
              <text x={x+PW/2} y={30} textAnchor="middle" fontSize="12" fill={color} fontWeight="700">{title}</text>
              <text x={x+PW/2} y={45} textAnchor="middle" fontSize="10" fill={color} fontStyle="italic">{subtitle}</text>

              {/* Model estimate (blue dot) */}
              <circle cx={x+70} cy={cy} r={22} fill={LTBLU} stroke={BLUE} strokeWidth="2"/>
              <text x={x+70} y={cy+4} textAnchor="middle" fontSize="9" fill={BLUE} fontWeight="700">model</text>
              <text x={x+70} y={cy+16} textAnchor="middle" fontSize="8" fill={BLUE}>x_hat_pred</text>

              {/* Measurement (orange dot) */}
              <circle cx={x+200} cy={cy} r={22} fill={LTORG} stroke={ORANGE} strokeWidth="2"/>
              <text x={x+200} y={cy+4} textAnchor="middle" fontSize="9" fill={ORANGE} fontWeight="700">sensor</text>
              <text x={x+200} y={cy+16} textAnchor="middle" fontSize="8" fill={ORANGE}>y_k</text>

              {/* Result dot */}
              {(() => {
                const rx2 = x + 70 + K * (200 - 70);
                return (
                  <g>
                    <line x1={x+70} y1={cy-40} x2={x+200} y2={cy-40} stroke="#eee" strokeWidth="1"/>
                    <line x1={x+70} y1={cy-44} x2={x+70} y2={cy-36} stroke={BLUE} strokeWidth="1.5"/>
                    <line x1={x+200} y1={cy-44} x2={x+200} y2={cy-36} stroke={ORANGE} strokeWidth="1.5"/>
                    <circle cx={rx2} cy={cy-40} r={7} fill={color} opacity="0.9"/>
                    <text x={rx2} y={cy-52} textAnchor="middle" fontSize="9" fill={color} fontWeight="700">x_hat_new</text>
                    <text x={rx2} y={cy-41} textAnchor="middle" fontSize="7" fill="#fff" fontWeight="700">K={K}</text>
                  </g>
                );
              })()}

              {/* Weight bar */}
              <rect x={x+14} y={cy+38} width={PW-28} height={16} rx={3} fill="#f0f0f0"/>
              <rect x={x+14} y={cy+38} width={(PW-28)*modelW} height={16} rx={3} fill={BLUE} opacity="0.6"/>
              <rect x={x+14+(PW-28)*modelW} y={cy+38} width={(PW-28)*sensW} height={16} rx={3} fill={ORANGE} opacity="0.6"/>
              <text x={x+14+(PW-28)*modelW/2} y={cy+50} textAnchor="middle" fontSize="8" fill="#fff">model</text>
              <text x={x+14+(PW-28)*(modelW+sensW/2)} y={cy+50} textAnchor="middle" fontSize="8" fill="#fff">sensor</text>
              <text x={x+PW/2} y={cy+68} textAnchor="middle" fontSize="9" fill="#888">weight balance</text>

              {/* Formula */}
              <rect x={x+8} y={cy+74} width={PW-16} height={24} rx={3} fill={color === BLUE ? LTBLU : color===GREEN ? LTGRN : LTORG} stroke={color} strokeWidth="1"/>
              <text x={x+PW/2} y={cy+90} textAnchor="middle" fontSize="10" fill={color} fontWeight="700">K = {K} (K = P_pred/(P_pred+R))</text>

              {desc.map((t, i) => (
                <text key={i} x={x+10} y={cy+110+i*17} fontSize="9.5" fill="#333">{t}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>
        The Kalman gain K = P_pred / (P_pred + R) determines how much weight is given to the new measurement vs the model prediction. K near 0 means high sensor noise R -- trust the model. K near 1 means high model uncertainty P_pred -- trust the sensor. The resulting estimate x_hat lies between the prediction and measurement, weighted by their relative confidence levels.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 6 -- Full multivariate block diagram
// =================================================================
function DiagramMultivariate() {
  const W = 900, H = 360;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Multivariate Kalman Filter -- Complete Equations Reference</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Two columns: Predict and Update */}
        <rect x={10} y={10} width={425} height={340} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={10} y={10} width={425} height={36} rx={5} fill={BLUE} opacity="0.12"/>
        <text x={222} y={34} textAnchor="middle" fontSize="14" fill={BLUE} fontWeight="700">PREDICT (Time Update)</text>

        {[
          {
            y: 54, label: 'State prediction', color: BLUE, bg: LTBLU,
            eq: 'x_hat_k|k-1 = A * x_hat_k-1|k-1 + B * u_k',
            note: 'Propagate estimate using system dynamics',
          },
          {
            y: 112, label: 'Covariance prediction', color: PURPLE, bg: LTPUR,
            eq: 'P_k|k-1 = A * P_k-1|k-1 * A^T + Q',
            note: 'Propagate uncertainty; Q adds process noise',
          },
          {
            y: 170, label: 'Process noise Q', color: TEAL, bg: LTTEAL,
            eq: 'Q = E[w_k * w_k^T]  (n x n, positive semidefinite)',
            note: 'Covariance of process disturbance w_k',
          },
          {
            y: 228, label: 'Predict summary', color: BLUE, bg: LTBLU,
            eq: 'Inputs: x_hat_{k-1|k-1}, P_{k-1|k-1}, u_k',
            note: 'Outputs: x_hat_{k|k-1}, P_{k|k-1}',
          },
        ].map(({ y, label, color, bg, eq, note }) => (
          <g key={y}>
            <rect x={18} y={y} width={409} height={54} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
            <text x={26} y={y+16} fontSize="11" fill={color} fontWeight="700">{label}</text>
            <text x={26} y={y+31} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{eq}</text>
            <text x={26} y={y+47} fontSize="9.5" fill="#666">{note}</text>
          </g>
        ))}

        <rect x={455} y={10} width={435} height={340} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={455} y={10} width={435} height={36} rx={5} fill={ORANGE} opacity="0.12"/>
        <text x={672} y={34} textAnchor="middle" fontSize="14" fill={ORANGE} fontWeight="700">UPDATE (Measurement Update)</text>

        {[
          {
            y: 54, label: 'Innovation (residual)', color: GREEN, bg: LTGRN,
            eq: 'nu_k = y_k - C * x_hat_k|k-1',
            note: 'Difference between measurement and prediction',
          },
          {
            y: 112, label: 'Innovation covariance', color: TEAL, bg: LTTEAL,
            eq: 'S_k = C * P_k|k-1 * C^T + R',
            note: 'Total uncertainty in innovation (model + sensor)',
          },
          {
            y: 170, label: 'Kalman gain', color: RED, bg: LTRED,
            eq: 'K_k = P_k|k-1 * C^T * S_k^(-1)',
            note: 'Optimal weighting -- derived from minimising trace(P_k|k)',
          },
          {
            y: 228, label: 'State update', color: ORANGE, bg: LTORG,
            eq: 'x_hat_k|k = x_hat_k|k-1 + K_k * nu_k',
            note: 'Correct estimate using scaled innovation',
          },
          {
            y: 286, label: 'Covariance update', color: PURPLE, bg: LTPUR,
            eq: 'P_k|k = (I - K_k * C) * P_k|k-1',
            note: 'Joseph form: P = (I-KC)P(I-KC)^T + KRK^T (stable)',
          },
        ].map(({ y, label, color, bg, eq, note }) => (
          <g key={y}>
            <rect x={463} y={y} width={419} height={54} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
            <text x={471} y={y+16} fontSize="11" fill={color} fontWeight="700">{label}</text>
            <text x={471} y={y+31} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{eq}</text>
            <text x={471} y={y+47} fontSize="9.5" fill="#666">{note}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The full multivariate Kalman filter equations in compact form. All quantities are matrices: x_hat is n x 1, P is n x n, K is n x q (q = output dimension), S is q x q. The Kalman gain K is derived analytically by minimising the trace of the updated covariance P_k|k -- no iteration is needed. The Joseph form of the covariance update is numerically more stable than the simpler (I-KC)*P form.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 7 -- Discrete vs continuous Kalman, Riccati equation
// =================================================================
function DiagramRiccati() {
  const W = 900, H = 340;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Steady-State Kalman Filter and the Algebraic Riccati Equation</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left: Discrete-time ARE */}
        <rect x={10} y={10} width={415} height={320} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={10} y={10} width={415} height={36} rx={5} fill={BLUE} opacity="0.1"/>
        <text x={222} y={34} textAnchor="middle" fontSize="13" fill={BLUE} fontWeight="700">Discrete-Time Steady-State (DARE)</text>

        <rect x={18} y={54} width={399} height={52} rx={4} fill={LTBLU} stroke={BLUE} strokeWidth="1.5"/>
        <text x={222} y={74} textAnchor="middle" fontSize="11" fill={BLUE} fontWeight="700" fontFamily="'Courier New',monospace">P = A*P*A^T - A*P*C^T*(C*P*C^T+R)^(-1)*C*P*A^T + Q</text>
        <text x={222} y={92} textAnchor="middle" fontSize="9.5" fill="#555">Solve for P (positive definite) -- DARE equation</text>
        <text x={222} y={104} textAnchor="middle" fontSize="9.5" fill="#555">MATLAB: [P,K_ss] = dare(A^T, C^T, Q, R)  then  L_ss = K_ss^T</text>

        {[
          { y:114, bg:LTGRN, bc:GREEN, lines:['When P converges to steady-state P_ss','Run filter recursion until P stops changing','Then use fixed L_ss = K_ss forever (offline computation)'] },
          { y:166, bg:LTBLU, bc:BLUE, lines:['Steady-state Kalman gain','L_ss = P_ss*C^T*(C*P_ss*C^T + R)^(-1)','This L_ss is IDENTICAL to the Luenberger gain'] },
          { y:218, bg:LTPUR, bc:PURPLE, lines:['Conditions for existence','(A, B_Q) must be stabilisable  (B_Q = sqrt(Q))',  '(A, C) must be detectable'] },
          { y:270, bg:LTTEAL, bc:TEAL, lines:['MATLAB one-liner','[~,L_ss,~] = kalman(ss(A,B,[C;eye(n)],0), Q, R, 0)','Or: L_ss = (lqr(A^T, C^T, Q, R))^T  (duality)'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={18} y={y} w={399} h={46} bg={bg} bc={bc} lines={lines}/>
        ))}

        {/* Right: Continuous-time ARE */}
        <rect x={455} y={10} width={435} height={320} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={455} y={10} width={435} height={36} rx={5} fill={ORANGE} opacity="0.1"/>
        <text x={672} y={34} textAnchor="middle" fontSize="13" fill={ORANGE} fontWeight="700">Continuous-Time Steady-State (CARE)</text>

        <rect x={463} y={54} width={419} height={52} rx={4} fill={LTORG} stroke={ORANGE} strokeWidth="1.5"/>
        <text x={672} y={74} textAnchor="middle" fontSize="11" fill={ORANGE} fontWeight="700" fontFamily="'Courier New',monospace">A*P + P*A^T - P*C^T*R^(-1)*C*P + Q = 0</text>
        <text x={672} y={92} textAnchor="middle" fontSize="9.5" fill="#555">Algebraic Riccati Equation (ARE): solve for P</text>
        <text x={672} y={104} textAnchor="middle" fontSize="9.5" fill="#555">MATLAB: P = care(A^T, C^T, Q, R)  then  L_ss = P*C^T*R^(-1)</text>

        {[
          { y:114, bg:LTGRN, bc:GREEN, lines:['Continuous-time steady-state gain','L_ss = P_ss * C^T * R^(-1)','Equivalent to LQR: L_ss = (lqr(A^T,C^T,Q,R))^T'] },
          { y:166, bg:LTORG, bc:ORANGE, lines:['Riccati solution properties','P_ss is unique, positive definite (if stabilisable+detectable)','Observer error poles: eig(A - L_ss*C) all in LHP'] },
          { y:218, bg:LTRED, bc:RED, lines:['Q and R tuning (continuous)','Q = process noise spectral density matrix (n x n)','R = measurement noise spectral density matrix (q x q)'] },
          { y:270, bg:LTPUR, bc:PURPLE, lines:['Dual of LQR','Kalman filter IS LQR applied to dual system','Min. E[||e||^2] corresponds to min. INT(e^T*Q*e)dt in LQR'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={463} y={y} w={419} h={46} bg={bg} bc={bc} lines={lines}/>
        ))}
      </svg>
      <div style={S.dCaption}>
        At steady state, the Kalman gain converges to a fixed matrix L_ss computed by solving the Algebraic Riccati Equation (ARE). This pre-computed gain can be stored and used as a fixed observer gain, making the steady-state Kalman filter computationally identical to the Luenberger observer. The DARE and CARE are dual to the LQR Riccati equations -- the Kalman filter is literally LQR applied to the transposed system.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 8 -- Extended Kalman Filter (EKF) linearisation
// =================================================================
function DiagramEKF() {
  const W = 900, H = 360;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Extended Kalman Filter (EKF) -- Linearising Nonlinear Systems</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left: nonlinear function with tangent approximation */}
        <rect x={10} y={10} width={340} height={340} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={180} y={28} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">Jacobian Linearisation at x_hat</text>

        {(() => {
          const bx = 25, by = 40, bw = 310, bh = 200;
          const toX2 = v => bx + (v+2)/5*bw;
          const toY2 = v => by + bh - v*bh*0.15;

          // Nonlinear function: f(x) = sin(x) + 0.5x + 2
          const fpts = Array.from({length:60}, (_,k) => {
            const x = -2 + k*5/59;
            const y = Math.sin(x) + 0.5*x + 2;
            return toX2(x)+','+toY2(y);
          }).join(' ');

          // Operating point
          const x0 = 0.8;
          const f0 = Math.sin(x0) + 0.5*x0 + 2;
          const df = Math.cos(x0) + 0.5; // derivative (Jacobian)

          // Tangent line
          const tpts = [-2, 2].map(x => toX2(x)+','+toY2(f0 + df*(x-x0))).join(' ');

          return (
            <g>
              <rect x={bx} y={by} width={bw} height={bh} rx={3} fill="#fafafa" stroke="#eee"/>
              <line x1={bx} y1={by+bh/2} x2={bx+bw} y2={by+bh/2} stroke="#ddd" strokeWidth="1"/>
              <line x1={bx+bw/2*2/5*5} y1={by} x2={bx+bw/2*2/5*5} y2={by+bh} stroke="#ddd" strokeWidth="1"/>

              {/* Nonlinear function */}
              <polyline points={fpts} fill="none" stroke={BLUE} strokeWidth="2.5"/>
              {/* Tangent (linear approx) */}
              <polyline points={tpts} fill="none" stroke={RED} strokeWidth="1.8" strokeDasharray="6 3"/>
              {/* Operating point */}
              <circle cx={toX2(x0)} cy={toY2(f0)} r={7} fill={ORANGE}/>
              <text x={toX2(x0)+10} y={toY2(f0)-8} fontSize="9.5" fill={ORANGE} fontWeight="700">x_hat (operating pt)</text>

              {/* Labels */}
              <text x={bx+bw-4} y={by+bh/2-4} textAnchor="end" fontSize="10" fill={BLUE} fontWeight="700">f(x) nonlinear</text>
              <text x={bx+bw-4} y={toY2(f0 + df*(2-x0))-4} textAnchor="end" fontSize="10" fill={RED}>F = df/dx|_x_hat</text>
            </g>
          );
        })()}

        {/* EKF equations */}
        {[
          { y:256, bg:LTBLU, bc:BLUE, lines:['EKF Predict','x_hat- = f(x_hat, u)  (propagate with full nonlinear model)','P- = F * P * F^T + Q  (F = Jacobian df/dx at x_hat)'] },
          { y:302, bg:LTORG, bc:ORANGE, lines:['EKF Update','K = P-*H^T*(H*P-*H^T+R)^(-1)  (H = Jacobian dh/dx at x_hat-)','x_hat = x_hat- + K*(y - h(x_hat-))  (h = nonlinear output)'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={18} y={y} w={324} h={46} bg={bg} bc={bc} lines={lines}/>
        ))}

        {/* Right: EKF steps comparison */}
        <rect x={365} y={10} width={525} height={340} rx={5} fill="#fff" stroke={BORDER}/>
        <text x={627} y={28} textAnchor="middle" fontSize="12" fill={DKRED} fontWeight="700">Linear KF vs EKF vs UKF Comparison</text>

        {[
          {
            y: 36, color: BLUE, bg: LTBLU,
            row: ['Linear KF', 'x = Ax + Bu + w', 'y = Cx + v', 'Exact optimal for linear+Gaussian'],
          },
          {
            y: 94, color: ORANGE, bg: LTORG,
            row: ['EKF', 'x = f(x,u) + w', 'y = h(x) + v', 'Linearise at x_hat; 1st-order approx'],
          },
          {
            y: 152, color: PURPLE, bg: LTPUR,
            row: ['UKF', 'x = f(x,u) + w', 'y = h(x) + v', 'Sigma points; better for high nonlinearity'],
          },
          {
            y: 210, color: TEAL, bg: LTTEAL,
            row: ['Particle Filter', 'Any p(x)', 'Any p(y|x)', 'Monte Carlo; exact but expensive'],
          },
        ].map(({ y, color, bg, row }) => (
          <g key={y}>
            <rect x={373} y={y} width={509} height={54} rx={3} fill={bg} stroke={color} strokeWidth="1"/>
            <text x={381} y={y+15} fontSize="11" fill={color} fontWeight="700">{row[0]}</text>
            <text x={381} y={y+29} fontSize="9.5" fill="#333" fontFamily="'Courier New',monospace">Process: {row[1]}</text>
            <text x={381} y={y+43} fontSize="9.5" fill="#333" fontFamily="'Courier New',monospace">Output:  {row[2]}</text>
            <text x={720} y={y+29} fontSize="9.5" fill={color} fontStyle="italic">{row[3]}</text>
          </g>
        ))}

        {/* EKF failure mode */}
        <rect x={373} y={270} width={509} height={70} rx={3} fill={LTRED} stroke={RED} strokeWidth="1"/>
        <text x={381} y={286} fontSize="11" fill={RED} fontWeight="700">EKF Limitations:</text>
        {[
          '- Divergence if nonlinearity is severe (linearisation too crude)',
          '- No guaranteed stability -- can diverge with bad initial conditions',
          '- Jacobian computation can be complex (analytical or numerical)',
          '- Sub-optimal: not true minimum-variance estimator for nonlinear systems',
        ].map((t, i) => (
          <text key={i} x={381} y={300+i*14} fontSize="9.5" fill="#555">{t}</text>
        ))}
      </svg>
      <div style={S.dCaption}>
        The Extended Kalman Filter extends the linear Kalman filter to nonlinear systems by linearising the dynamics f(x,u) and output h(x) at the current estimate using Jacobian matrices F = df/dx and H = dh/dx. The nonlinear model is used for propagation; the Jacobians are used only in the covariance equations. This first-order approximation works well when nonlinearities are mild but can diverge for highly nonlinear systems.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 9 -- UKF sigma points
// =================================================================
function DiagramUKF() {
  const W = 900, H = 330;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Unscented Kalman Filter (UKF) -- Sigma Points vs Linearisation</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Left: EKF approach */}
        <rect x={10} y={10} width={280} height={310} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={10} y={10} width={280} height={30} rx={5} fill={RED} opacity="0.1"/>
        <text x={150} y={30} textAnchor="middle" fontSize="12" fill={RED} fontWeight="700">EKF: Linearise then Transform</text>

        {(() => {
          const bx=25, by=48, bw=250, bh=150;
          // Gaussian as ellipse (2D)
          const cx=bx+bw*0.35, cy=by+bh*0.5;
          // After nonlinear transform: banana shape approximated
          const cxT=bx+bw*0.75, cyT=by+bh*0.5;

          return (
            <g>
              {/* Input distribution */}
              <ellipse cx={cx} cy={cy} rx={45} ry={35} fill={LTBLU} stroke={BLUE} strokeWidth="1.5" opacity="0.7"/>
              <text x={cx} y={cy+4} textAnchor="middle" fontSize="9" fill={BLUE} fontWeight="700">Prior N(mu,P)</text>

              {/* Arrow through nonlinear fn */}
              <Arr x1={cx+50} y1={cy} x2={cxT-45} y2={cy} color="#888" marker="aGray" lbl="f(x)" lx={(cx+50+cxT-45)/2} ly={cy-8}/>

              {/* True output (banana/non-Gaussian) */}
              <path d={'M '+(cxT-30)+','+(cyT-40)+' Q '+(cxT+50)+','+(cyT-10)+' '+(cxT+20)+','+(cyT+40)+' Q '+(cxT-50)+','+(cyT+20)+' '+(cxT-30)+','+(cyT-40)} fill={LTGRN} stroke={GREEN} strokeWidth="1.5" opacity="0.6"/>
              <text x={cxT} y={cyT+4} textAnchor="middle" fontSize="8" fill={GREEN}>True f(prior)</text>
              <text x={cxT} y={cyT+16} textAnchor="middle" fontSize="8" fill={GREEN}>(non-Gaussian)</text>

              {/* EKF approximation (wrong ellipse) */}
              <ellipse cx={cxT} cy={cyT} rx={30} ry={40} fill="none" stroke={RED} strokeWidth="1.5" strokeDasharray="5 3"/>
              <text x={cxT} y={cyT-48} textAnchor="middle" fontSize="9" fill={RED}>EKF approx</text>
              <text x={cxT} y={cyT-36} textAnchor="middle" fontSize="8" fill={RED}>(often wrong!)</text>
            </g>
          );
        })()}

        {[
          { y:208, bg:LTRED, bc:RED, lines:['EKF issue','Linearise f at x_hat -> loses shape of nonlinearity','Gaussian approx is poor for high curvature'] },
          { y:258, bg:LTBLU, bc:BLUE, lines:['Jacobian','F = df/dx evaluated at x_hat','Accurate only near operating point'] },
        ].map(({ y, bg, bc, lines }) => (
          <Card key={y} x={18} y={y} w={264} h={42} bg={bg} bc={bc} lines={lines}/>
        ))}

        {/* Right: UKF approach */}
        <rect x={305} y={10} width={585} height={310} rx={5} fill="#fff" stroke={BORDER}/>
        <rect x={305} y={10} width={585} height={30} rx={5} fill={ORANGE} opacity="0.1"/>
        <text x={597} y={30} textAnchor="middle" fontSize="12" fill={ORANGE} fontWeight="700">UKF: Transform Sigma Points then Fit Gaussian</text>

        {/* Sigma points diagram */}
        {(() => {
          const bx=318, by=46, bw=260, bh=160;
          const cx=bx+bw*0.35, cy=by+bh*0.5;
          const cxT=bx+bw*0.8, cyT=by+bh*0.5;

          // Sigma points (2n+1 = 5 for n=2)
          const sigPts = [
            {dx:0,  dy:0,  w:0.2},  // mean
            {dx:40, dy:0,  w:0.2},
            {dx:-40,dy:0,  w:0.2},
            {dx:0,  dy:28, w:0.2},
            {dx:0,  dy:-28,w:0.2},
          ];
          // Transformed sigma points (after nonlinear f)
          const sigPtsT = [
            {dx:5,   dy:0,  w:0.2},
            {dx:55,  dy:20, w:0.2},
            {dx:-35, dy:-15,w:0.2},
            {dx:15,  dy:35, w:0.2},
            {dx:-5,  dy:-35,w:0.2},
          ];

          return (
            <g>
              {/* Input distribution */}
              <ellipse cx={cx} cy={cy} rx={50} ry={35} fill={LTBLU} stroke={BLUE} strokeWidth="1.5" opacity="0.5"/>
              {/* Sigma points */}
              {sigPts.map(({ dx, dy }, i) => (
                <g key={i}>
                  <circle cx={cx+dx} cy={cy+dy} r={5} fill={ORANGE} opacity="0.9"/>
                  <text x={cx+dx} y={cy+dy-7} textAnchor="middle" fontSize="8" fill={ORANGE}>X{i}</text>
                </g>
              ))}
              <text x={cx} y={by+bh+14} textAnchor="middle" fontSize="9" fill={BLUE}>Input sigma points</text>

              {/* Arrow */}
              <Arr x1={cx+55} y1={cy} x2={cxT-60} y2={cy} color="#888" marker="aGray" lbl="f(x)" lx={(cx+55+cxT-60)/2} ly={cy-8}/>

              {/* Transformed sigma points */}
              {sigPtsT.map(({ dx, dy }, i) => (
                <g key={i}>
                  <circle cx={cxT+dx} cy={cyT+dy} r={5} fill={RED} opacity="0.9"/>
                </g>
              ))}
              {/* Fitted Gaussian */}
              <ellipse cx={cxT+7} cy={cyT} rx={50} ry={38} fill="none" stroke={RED} strokeWidth="2" opacity="0.7"/>
              <text x={cxT} y={cyT} textAnchor="middle" fontSize="8" fill={RED}>Fit Gaussian</text>
              <text x={cxT} y={cyT+14} textAnchor="middle" fontSize="8" fill={RED}>to transformed pts</text>
              <text x={cxT} y={by+bh+14} textAnchor="middle" fontSize="9" fill={RED}>Transformed + fitted</text>
            </g>
          );
        })()}

        {/* UKF algorithm */}
        <rect x={315} y={218} width={568} height={92} rx={4} fill="#fff" stroke={BORDER}/>
        <text x={599} y={234} textAnchor="middle" fontSize="11" fill={DKRED} fontWeight="700">UKF Algorithm Summary</text>
        {[
          { x:323, color:ORANGE, lines:['1. Compute sigma points', 'X_i = x_hat +/- sqrt((n+kappa)*P) columns', '2n+1 points, weighted by W_i'] },
          { x:483, color:RED,    lines:['2. Propagate each sigma point', 'X_i- = f(X_i, u)  (no Jacobian needed!)', 'Captures full nonlinear shape'] },
          { x:643, color:PURPLE, lines:['3. Refit Gaussian', 'x_hat- = sum(W_i * X_i-)', 'P- = sum(W_i*(X_i--x_hat-)*(X_i--x_hat-)^T) + Q'] },
        ].map(({ x, color, lines }) => (
          <g key={x}>
            <rect x={x} y={242} width={152} height={60} rx={3} fill={color === ORANGE ? LTORG : color === RED ? LTRED : LTPUR} stroke={color} strokeWidth="1"/>
            {lines.map((t, i) => (
              <text key={i} x={x+6} y={257+i*15} fontSize="9" fill={i===0?color:'#333'} fontWeight={i===0?'700':'400'}>{t}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The Unscented Kalman Filter avoids the Jacobian altogether. Instead, it propagates a carefully chosen set of 2n+1 sigma points through the full nonlinear function f(x,u), then re-fits a Gaussian to the resulting cloud. This captures the mean and covariance to 3rd-order accuracy (vs 1st-order for EKF). The UKF is preferred when the nonlinearity is significant or the Jacobian is difficult to compute.
      </div>
    </div>
  );
}

// =================================================================
// Diagram 10 -- LQG full system (LQR + Kalman)
// =================================================================
function DiagramLQG() {
  const W = 900, H = 370;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>LQG Controller -- LQR State Feedback + Kalman Filter (Optimal Output Feedback)</div>
      <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width:'100%', display:'block' }}>
        <Defs/>

        {/* Plant */}
        <Blk x={340} y={60} w={160} h={52} fill={LTBLU} stroke={BLUE} label="PLANT" sub="x_dot=Ax+Bu+Gw, y=Cx+v"/>
        {/* Process noise w into plant */}
        <Arr x1={340} y1={74} x2={300} y2={74} color={TEAL} marker="aTeal" dash={true} lbl="w~N(0,Q)" lx={318} ly={65}/>
        {/* Measurement noise v */}
        <Arr x1={500} y1={30} x2={500} y2={60} color={PURPLE} marker="aPurple" dash={true} lbl="v~N(0,R)" lx={510} ly={44}/>

        {/* y out of plant */}
        <Arr x1={500} y1={86} x2={620} y2={86} color={GREEN} marker="aGreen" lbl="y" lx={558} ly={78}/>
        <circle cx={590} cy={86} r={5} fill={GREEN}/>

        {/* x out of plant (unknown) */}
        <Arr x1={340} y1={86} x2={220} y2={86} color={BLUE} marker="aBlue" lbl="x (unknown)" lx={278} ly={78}/>
        <text x={148} y={86} textAnchor="middle" fontSize="9" fill="#bbb">(not available)</text>

        {/* Kalman Filter block */}
        <rect x={620} y={48} width={180} height={80} rx={5} fill={LTORG} stroke={ORANGE} strokeWidth="2"/>
        <text x={710} y={76} textAnchor="middle" fontSize="13" fill={ORANGE} fontWeight="700">KALMAN</text>
        <text x={710} y={92} textAnchor="middle" fontSize="13" fill={ORANGE} fontWeight="700">FILTER</text>
        <text x={710} y={110} textAnchor="middle" fontSize="9" fill={ORANGE}>x_hat_dot=Ax_hat+Bu+L*(y-Cx_hat)</text>
        <text x={710} y={121} textAnchor="middle" fontSize="9" fill={ORANGE}>L = P*C^T*R^(-1)  (optimal)</text>

        {/* y to Kalman */}
        <Arr x1={590} y1={86} x2={620} y2={86} color={GREEN} marker="aGreen"/>

        {/* x_hat out of Kalman */}
        <Arr x1={710} y1={128} x2={710} y2={200} color={ORANGE} marker="aOrange" lbl="x_hat" lx={720} ly={165}/>
        <circle cx={710} cy={180} r={5} fill={ORANGE}/>

        {/* LQR block */}
        <rect x={590} y={200} width={240} height={60} rx={5} fill={LTRED} stroke={RED} strokeWidth="2"/>
        <text x={710} y={228} textAnchor="middle" fontSize="14" fill={RED} fontWeight="700">LQR CONTROLLER</text>
        <text x={710} y={246} textAnchor="middle" fontSize="10" fill={RED}>u = -K * x_hat  (K from Riccati/LQR)</text>

        {/* u back to plant */}
        <Arr x1={590} y1={230} x2={420} y2={230} color={RED} marker="aRed" lbl="u" lx={505} ly={222}/>
        <line x1={420} y1={230} x2={420} y2={86} stroke={RED} strokeWidth="1.8"/>
        <Arr x1={420} y1={86} x2={500} y2={86} color={RED} marker="aRed"/>
        <circle cx={420} cy={130} r={4} fill={RED}/>

        {/* u also to Kalman */}
        <line x1={420} y1={130} x2={610} y2={130} stroke={RED} strokeWidth="1.8"/>
        <Arr x1={610} y1={130} x2={620} y2={86} color={RED} marker="aRed" lbl="u fed to observer" lx={620} ly={118}/>

        {/* Reference */}
        <Arr x1={14} y1={228} x2={80} y2={228} color={RED} marker="aRed" lbl="r=0 (regulator)" lx={46} ly={220}/>
        <Blk x={80} y={210} w={50} h={36} fill={LTPUR} stroke={PURPLE} label="N" fs={11}/>
        <Arr x1={130} y1={228} x2={590} y2={228} color={PURPLE} marker="aPurple"/>

        {/* Bottom info boxes */}
        <rect x={10} y={290} width={280} height={70} rx={4} fill={LTBLU} stroke={BLUE} strokeWidth="1"/>
        <text x={150} y={308} textAnchor="middle" fontSize="11" fill={BLUE} fontWeight="700">LQR designs K:</text>
        <text x={18} y={324} fontSize="9.5" fill="#444">Minimise J = INT(x^T*Q_x*x + u^T*R_u*u)dt</text>
        <text x={18} y={338} fontSize="9.5" fill="#444">K = R_u^(-1)*B^T*P_x where A^T*P_x+P_x*A-P_x*B*R_u^(-1)*B^T*P_x+Q_x=0</text>
        <text x={18} y={352} fontSize="9.5" fill={BLUE}>Result: optimal state feedback gain K</text>

        <rect x={310} y={290} width={280} height={70} rx={4} fill={LTORG} stroke={ORANGE} strokeWidth="1"/>
        <text x={450} y={308} textAnchor="middle" fontSize="11" fill={ORANGE} fontWeight="700">Kalman designs L:</text>
        <text x={318} y={324} fontSize="9.5" fill="#444">Minimise E[||x-x_hat||^2] given w~N(0,Q_w), v~N(0,R_v)</text>
        <text x={318} y={338} fontSize="9.5" fill="#444">L = P_e*C^T*R_v^(-1) where A*P_e+P_e*A^T-P_e*C^T*R_v^(-1)*C*P_e+Q_w=0</text>
        <text x={318} y={352} fontSize="9.5" fill={ORANGE}>Result: optimal observer gain L</text>

        <rect x={610} y={290} width={280} height={70} rx={4} fill={LTGRN} stroke={GREEN} strokeWidth="1"/>
        <text x={750} y={308} textAnchor="middle" fontSize="11" fill={GREEN} fontWeight="700">LQG (combined):</text>
        <text x={618} y={324} fontSize="9.5" fill="#444">Separation principle: design K and L independently</text>
        <text x={618} y={338} fontSize="9.5" fill="#444">Poles = eig(A-BK) union eig(A-LC) (total 2n poles)</text>
        <text x={618} y={352} fontSize="9.5" fill={GREEN}>Optimal output feedback for linear+Gaussian systems</text>
      </svg>
      <div style={S.dCaption}>
        The Linear Quadratic Gaussian (LQG) controller combines LQR (optimal state feedback) with the Kalman filter (optimal state estimator). LQR minimises a quadratic cost on states and inputs; the Kalman filter minimises estimation error variance. By the separation principle, K and L are designed independently using their respective Riccati equations, with different weighting matrices (Q_x/R_u for LQR, Q_w/R_v for Kalman). Together they form the optimal output feedback controller for linear time-invariant systems with Gaussian noise.
      </div>
    </div>
  );
}

// =================================================================
// Main
// =================================================================
export default function KalmanFilter() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>The Kalman Filter</h1>
      <p style={S.p}>
        The Kalman filter, developed by Rudolf E. Kalman in 1960, is the optimal recursive estimator for linear systems with Gaussian noise. It answers the question: given a noisy, incomplete set of measurements, what is the best possible estimate of the true state? The filter operates by alternating between two steps -- predicting the next state using the system model, then correcting that prediction using a new sensor measurement -- each step updating a probability distribution that captures both the estimate and the uncertainty in that estimate.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "Two-step loop: PREDICT (time update with model) then UPDATE (measurement correction)",
        "State estimate: x_hat_k|k = x_hat_k|k-1 + K_k*(y_k - C*x_hat_k|k-1)",
        "Kalman gain: K_k = P_k|k-1 * C^T * (C*P_k|k-1*C^T + R)^(-1)  -- optimal weighting",
        "Covariance: P tracks uncertainty; shrinks on update, grows on predict",
        "Process noise Q: models disturbances to the system (how much model drift)",
        "Measurement noise R: models sensor inaccuracy (how noisy the sensor is)",
        "Optimal: minimises E[||x - x_hat||^2] for linear systems with Gaussian noise",
        "Steady-state: K converges to fixed K_ss via Algebraic Riccati Equation (ARE)",
        "LQG = LQR (K) + Kalman filter (L): optimal output feedback for linear-Gaussian systems",
      ]}/>

      <h2 style={S.h2}>The Predict-Update Cycle</h2>
      <p style={S.p}>
        Every iteration of the Kalman filter consists of exactly two steps. The Predict step uses the system dynamics model to project the current estimate forward in time -- it is a pure model calculation and always increases uncertainty. The Update step then incorporates the latest sensor measurement to correct the prediction and reduce uncertainty. This two-step structure allows the filter to run recursively in real time with a fixed, small computational cost per step.
      </p>
      <DiagramPredictUpdate/>
      <Table2 rows={[
        ["Predict: state","x_hat_k|k-1 = A * x_hat_k-1|k-1 + B * u_k\nPropagate last estimate forward using system matrix A and known input u"],
        ["Predict: covariance","P_k|k-1 = A * P_k-1|k-1 * A^T + Q\nUncertainty grows: A spreads the current P, Q adds process noise"],
        ["Update: innovation","nu_k = y_k - C * x_hat_k|k-1\nDifference between actual measurement and predicted measurement"],
        ["Update: Kalman gain","K_k = P_k|k-1 * C^T * (C * P_k|k-1 * C^T + R)^(-1)\nWeights model vs measurement trust; derived from min-variance criterion"],
        ["Update: state","x_hat_k|k = x_hat_k|k-1 + K_k * nu_k\nPull estimate toward measurement by amount K_k"],
        ["Update: covariance","P_k|k = (I - K_k * C) * P_k|k-1\nUncertainty shrinks: measurement has reduced our ignorance"],
      ]}/>

      <h2 style={S.h2}>Bayesian Intuition: Gaussian Fusion</h2>
      <p style={S.p}>
        At its core, the Kalman filter is a Bayesian estimator. After the predict step, the current belief about the state is a Gaussian (the prior). When a measurement arrives, it provides another Gaussian (the likelihood). The update step fuses these two Gaussians to produce a posterior that is tighter than either input -- the filter combines information from two sources to reduce total uncertainty. This is the geometric heart of the filter.
      </p>
      <DiagramGaussianIntuition/>
      <Table2 rows={[
        ["Prior","Current belief before measurement: N(x_hat_pred, P_pred)\nWide if model prediction is uncertain (large P)"],
        ["Likelihood","What the measurement says: N(y, R)\nNarrow if sensor is accurate (small R)"],
        ["Posterior","Fused belief after measurement: N(x_hat_updated, P_updated)\nAlways tighter than either prior or likelihood"],
        ["1D fusion formulas","mu_post = mu_prior + K*(z - mu_prior)\nK = P_prior/(P_prior + R)  (scalar Kalman gain)"],
        ["Variance fusion","P_post = P_prior * R / (P_prior + R)  (harmonic mean style)\nAlternately: P_post = (1-K)*P_prior  (same result)"],
        ["Optimality","Posterior mean = maximum a posteriori (MAP) estimate\nAlso = minimum mean-squared error (MMSE) estimate for Gaussian noise"],
      ]}/>

      <h2 style={S.h2}>1D Scalar Worked Example</h2>
      <p style={S.p}>
        A 1D random walk (position drifting due to unknown acceleration) observed through a noisy sensor illustrates every equation in concrete numbers. The filter table shows how the Kalman gain stabilises after a few steps, how the innovation captures the residual between model and reality, and how the estimate tracks the true state despite noisy measurements.
      </p>
      <DiagramScalarExample/>
      <Table2 rows={[
        ["System model","x_k = x_k-1 + w_k  (random walk)  w_k ~ N(0, Q=1)\nQ=1 means we expect the state to drift by about 1 unit per step"],
        ["Measurement model","y_k = x_k + v_k  (direct observation)  v_k ~ N(0, R=4)\nR=4 means sensor standard deviation is 2 units"],
        ["Predict step","x_hat_pred = x_hat  (A=1 for random walk)\nP_pred = P + Q  (uncertainty grows by Q each step)"],
        ["Update step","K = P_pred / (P_pred + R)\nx_hat_new = x_hat_pred + K*(y - x_hat_pred)"],
        ["Steady-state K","K_ss = P_ss / (P_ss + R)  where P_ss = Q/2 + sqrt((Q/2)^2 + Q*R)\nFor Q=1, R=4: P_ss = 2.56, K_ss = 0.39"],
        ["Interpretation","K_ss = 0.39 means the filter weights measurement at 39% and model at 61%\nReasonable given sensor noise is 4x the process noise"],
      ]}/>

      <h2 style={S.h2}>Covariance Evolution and Gain Convergence</h2>
      <p style={S.p}>
        The covariance matrix P quantifies the filter's uncertainty about the state estimate. It oscillates between growing (predict step, +Q) and shrinking (update step, -K*C*P) each cycle. The key insight is that P converges to a steady-state value P_ss that depends only on Q and R -- regardless of the initial uncertainty. This convergence means the Kalman gain K also converges, and the filter eventually behaves like a fixed-gain linear observer.
      </p>
      <DiagramCovarianceGain/>
      <Table2 rows={[
        ["Covariance oscillation","Each cycle: P_pred = P + Q (grows); P_updated = (I-KC)*P_pred (shrinks)\nNet steady-state: growth from Q exactly balanced by reduction from measurement"],
        ["Steady-state P","Solve discrete ARE: P_ss = A*P_ss*A^T - A*P_ss*C^T*(C*P_ss*C^T+R)^(-1)*C*P_ss*A^T + Q\nMATLAB: P_ss = dare(A, C, Q, R) -- or run filter to convergence"],
        ["Steady-state K","K_ss = P_ss*C^T*(C*P_ss*C^T + R)^(-1)\nOnce converged: use this fixed K_ss -- no need to update P online"],
        ["Convergence rate","Depends on ratio Q/R and eigenvalues of A\nLarger Q/R (noisy model) or fast A: faster convergence to steady state"],
        ["Filter initialisation","P_0 = large matrix (high initial uncertainty)\nLarge P_0 means K near 1 initially: trust measurements early on"],
        ["Divergence prevention","P must remain positive definite: use Joseph form (I-KC)P(I-KC)^T + KRK^T\nNumerical errors in standard form can cause P to lose positive definiteness"],
      ]}/>

      <h2 style={S.h2}>Kalman Gain Intuition</h2>
      <p style={S.p}>
        The Kalman gain K = P_pred * C^T * (C*P_pred*C^T + R)^(-1) is the mathematical expression of a simple idea: trust the source that is more certain. When the model is uncertain (large P_pred) relative to the sensor (small R), K is large -- trust the measurement. When the sensor is noisy (large R) relative to the model (small P_pred), K is small -- trust the model.
      </p>
      <DiagramGainIntuition/>
      <Table2 rows={[
        ["K = 0 (ignore measurement)","Happens when R is infinite (infinitely noisy sensor)\nOr P_pred = 0 (perfectly known state -- no update needed)"],
        ["K = 1 (replace with measurement)","Happens when R = 0 (perfect sensor, no noise)\nOr P_pred is infinite (completely unknown state)"],
        ["K between 0 and 1 (SISO)","Weighted average: x_hat_new = (1-K)*x_hat_pred + K*y\nNew estimate lies between model and measurement"],
        ["MIMO K","K is n x q matrix (not scalar for multivariate systems)\nEach row weights how much each output y_i corrects state j"],
        ["Effect on P","P_new = (I - K*C)*P_pred  --  uncertainty always decreases after update\nLarger K = more reduction in P (more information extracted from y)"],
        ["Optimal K derivation","Minimise trace(P_k|k) wrt K: differentiating gives K = P_pred*C^T*(C*P_pred*C^T+R)^(-1)\nThis K simultaneously minimises variance of every component of the error"],
      ]}/>

      <h2 style={S.h2}>Complete Multivariate Equations</h2>
      <p style={S.p}>
        The multivariate Kalman filter generalises the scalar case to systems with multiple states (n), inputs (p), and outputs (q). All scalar quantities become matrices, but the structure is identical. The key new quantity is the innovation covariance S_k = C*P_pred*C^T + R, which measures total output uncertainty and is the matrix that must be inverted to compute K.
      </p>
      <DiagramMultivariate/>
      <Table2 rows={[
        ["Matrix dimensions","x: n x 1, P: n x n, K: n x q, Q: n x n, R: q x q\nA: n x n, B: n x p, C: q x n, u: p x 1, y: q x 1"],
        ["Innovation covariance S","S_k = C * P_k|k-1 * C^T + R\nTotal uncertainty in output space; q x q matrix; must be inverted"],
        ["Kalman gain K (matrix form)","K_k = P_k|k-1 * C^T * S_k^(-1)\nFor large q: S inversion is the most expensive step (O(q^3))"],
        ["Joseph form for P","P = (I-KC)*P_pred*(I-KC)^T + K*R*K^T\nNumerically stable; equivalent to (I-KC)*P_pred but handles floating-point errors"],
        ["Computational cost","O(n^2*q) per step dominated by matrix multiplications\nFor large n: use square-root filters to maintain P^(1/2) directly"],
        ["MATLAB implementation","kf = kalmanFilter(ss(A,[B,eye(n)],C,0,Ts),'ProcessNoise',Q,'MeasurementNoise',R)\nOr implement manually with the 5 equations"],
      ]}/>

      <h2 style={S.h2}>Steady-State Filter and Riccati Equation</h2>
      <p style={S.p}>
        For time-invariant systems, P converges to a fixed steady-state value P_ss after a few steps. The steady-state Kalman gain L_ss = P_ss*C^T*R^(-1) can be computed offline by solving the Algebraic Riccati Equation, making the filter computationally identical to a fixed-gain Luenberger observer. This connection to the Luenberger observer shows that the Kalman filter is the optimal choice of observer gain.
      </p>
      <DiagramRiccati/>
      <Table2 rows={[
        ["Discrete ARE (DARE)","P = A*P*A^T - A*P*C^T*(C*P*C^T+R)^(-1)*C*P*A^T + Q\nMATLAB: [P,L,e] = dare(A^T, C^T, Q, R)  then  L_ss = L^T"],
        ["Continuous ARE (CARE)","A*P + P*A^T - P*C^T*R^(-1)*C*P + Q = 0\nMATLAB: P = care(A^T, C^T, Q, R)  then  L_ss = P*C^T*R^(-1)"],
        ["Existence conditions","(A, Q^(1/2)) must be stabilisable: unstable modes must be driven by noise\n(A, C) must be detectable: all unstable modes must be visible in y"],
        ["Steady-state gain","L_ss = P_ss * C^T * (C * P_ss * C^T + R)^(-1)\nThis is the Luenberger gain that is optimal for the given Q and R"],
        ["Duality to LQR","Kalman gain: L_ss = (lqr(A^T, C^T, Q, R))^T\nExact same Riccati structure -- Kalman IS LQR on dual system"],
        ["MATLAB shortcut","L_ss = (lqr(A', C', Q, R))'  (using exact duality)\nOr: [K_f,P_f] = kalman(sys, Q, R) for full filter object"],
      ]}/>

      <h2 style={S.h2}>Extended Kalman Filter (EKF)</h2>
      <p style={S.p}>
        The standard Kalman filter requires a linear system. The Extended Kalman Filter (EKF) handles nonlinear systems by linearising around the current estimate at each time step. The state is propagated using the full nonlinear model, but the covariance equations use Jacobian matrices evaluated at the current estimate. This first-order approximation works well for mildly nonlinear systems such as robot navigation and satellite attitude estimation.
      </p>
      <DiagramEKF/>
      <Table2 rows={[
        ["System model","x_k = f(x_k-1, u_k) + w_k  (nonlinear dynamics)\ny_k = h(x_k) + v_k  (nonlinear output)"],
        ["Jacobians","F_k = df/dx evaluated at x_hat_k-1|k-1  (state Jacobian)\nH_k = dh/dx evaluated at x_hat_k|k-1  (output Jacobian)"],
        ["EKF predict","x_hat_k|k-1 = f(x_hat_k-1|k-1, u_k)  (full nonlinear propagation)\nP_k|k-1 = F_k * P_k-1|k-1 * F_k^T + Q  (linearised covariance)"],
        ["EKF update","K_k = P_k|k-1 * H_k^T * (H_k*P_k|k-1*H_k^T + R)^(-1)\nx_hat_k|k = x_hat_k|k-1 + K_k*(y_k - h(x_hat_k|k-1))"],
        ["EKF limitations","First-order only: linearisation error can cause divergence\nJacobian computation can be complex for highly nonlinear f and h"],
        ["Applications","GPS-IMU fusion (robot navigation), satellite attitude, target tracking\nWorks well when nonlinearity is mild and initial estimate is good"],
      ]}/>

      <h2 style={S.h2}>Unscented Kalman Filter (UKF)</h2>
      <p style={S.p}>
        The Unscented Kalman Filter (UKF) improves on the EKF by propagating a set of carefully chosen sigma points through the nonlinear function instead of linearising it. This captures the mean and covariance of the transformed distribution to 3rd-order accuracy (vs 1st-order for EKF) without requiring Jacobians. The UKF is preferred when the system is strongly nonlinear or the Jacobian is computationally expensive.
      </p>
      <DiagramUKF/>
      <Table2 rows={[
        ["Sigma points","2n+1 points: X_0 = x_hat, X_i = x_hat +/- sqrt((n+kappa)*P) columns\nCapture mean and covariance of prior distribution exactly"],
        ["Propagation","Each sigma point propagated through full nonlinear f: Y_i = f(X_i, u)\nNo linearisation required -- nonlinearity fully captured"],
        ["Refit Gaussian","x_hat_pred = sum(W_i * Y_i)  (weighted mean)\nP_pred = sum(W_i * (Y_i-x_hat_pred)*(Y_i-x_hat_pred)^T) + Q"],
        ["Accuracy","Captures up to 3rd-order terms in Taylor expansion (vs 1st for EKF)\nExact for any Gaussian prior transformed by any polynomial up to 3rd order"],
        ["Cost vs EKF","2n+1 function evaluations per step (vs 1 for EKF)\nNo Jacobian needed -- can use black-box nonlinear models"],
        ["When to use","Strongly nonlinear systems where EKF diverges\nWhen Jacobian is expensive/unavailable; initial uncertainty is large"],
      ]}/>

      <h2 style={S.h2}>LQG -- The Optimal Output Feedback Controller</h2>
      <p style={S.p}>
        Combining the Linear Quadratic Regulator (LQR) for state feedback with the Kalman filter for state estimation yields the Linear Quadratic Gaussian (LQG) controller -- the provably optimal output feedback controller for linear time-invariant systems with Gaussian noise. LQG is the cornerstone of modern optimal control: two independent Riccati equations are solved, one for the controller gain K and one for the estimator gain L, and by the separation principle the resulting combined system is stable and optimal.
      </p>
      <DiagramLQG/>
      <Table2 rows={[
        ["LQG structure","u = -K * x_hat  where x_hat comes from Kalman filter\nAll four matrices (A,B,C,D) used in both LQR and Kalman designs"],
        ["LQR Riccati (for K)","A^T*P_x + P_x*A - P_x*B*R_u^(-1)*B^T*P_x + Q_x = 0\nK = R_u^(-1)*B^T*P_x  -- minimises INT(x^T*Q_x*x + u^T*R_u*u)dt"],
        ["Kalman Riccati (for L)","A*P_e + P_e*A^T - P_e*C^T*R_v^(-1)*C*P_e + Q_w = 0\nL = P_e*C^T*R_v^(-1)  -- minimises E[||x - x_hat||^2]"],
        ["Separation principle","Combined poles = eig(A-BK) union eig(A-LC)\nK and L designed independently using different weighting matrices"],
        ["LQG limitations","Not robustly stable: LQG can have zero gain/phase margin (Doyle 1978)\nLTR (Loop Transfer Recovery) needed to restore robustness of LQR"],
        ["MATLAB","K = lqr(A,B,Q_x,R_u)  (LQR gain)\nL = (lqr(A^T,C^T,Q_w,R_v))^T  (Kalman gain via duality)"],
      ]}/>

      <h2 style={S.h2}>Summary: Choosing the Right Filter</h2>
      <Table2 rows={[
        ["Linear system, Gaussian noise","Standard Kalman Filter -- optimal, exact, efficient\nAll equations are linear; covariance update exact"],
        ["Need fixed-gain observer","Solve ARE for steady-state P, compute K_ss offline\nResults in Luenberger observer with optimal gain choice"],
        ["Mildly nonlinear system","Extended Kalman Filter (EKF) -- linearise at each step\nWorks well for navigation, tracking; fails for high nonlinearity"],
        ["Strongly nonlinear system","Unscented Kalman Filter (UKF) -- sigma points, no Jacobian\nBetter accuracy; slightly higher cost; still assumes Gaussian"],
        ["Very nonlinear or non-Gaussian","Particle filter -- Monte Carlo sampling, any distribution\nArbitrarily accurate but O(N) particles required; expensive"],
        ["Optimal output feedback","LQG = LQR + Kalman filter\nDesign K and L independently; add LTR for robustness"],
        ["MATLAB quick reference","kf: kalmanFilter(); ekf: extendedKalmanFilter(); ukf: unscentedKalmanFilter()\nLQG: [K,~,~]=lqr(A,B,Q,R); L=(lqr(A^T,C^T,Qw,Rv))^T"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "Predict:  x_hat- = A*x_hat + B*u   |   P- = A*P*A^T + Q",
        "Innovation:  nu = y - C*x_hat-   |   S = C*P-*C^T + R",
        "Kalman gain:  K = P- * C^T * S^(-1)  = P-*C^T*(C*P-*C^T+R)^(-1)",
        "Update:  x_hat = x_hat- + K*nu   |   P = (I - K*C)*P-",
        "Steady-state (CARE):  A*P + P*A^T - P*C^T*R^(-1)*C*P + Q = 0,  L = P*C^T*R^(-1)",
        "Duality: L = (lqr(A^T, C^T, Q, R))^T  (Kalman via LQR on transposed system)",
        "EKF Jacobians:  F = df/dx |_x_hat,  H = dh/dx |_x_hat-",
        "LQG:  K from lqr(A,B,Q_x,R_u)  +  L from kalman/dare/care  (independent designs)",
      ]}/>
    </div>
  );
}